
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting CRA_MONITORING_ERROR types, which identify a class of issues related to creating and managing Servicing subscriptions.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='CRA Monitoring Errors' subtitle='Guide to troubleshooting Servicing subscription errors' mdxType="Header" />
    <h4 {...{
      "id": "subscription_not_found"
    }}><strong parentName="h4">{`SUBSCRIPTION_NOT_FOUND`}</strong></h4>
    <ErrorReference type='CRA_MONITORING_ERROR' error='SUBSCRIPTION_NOT_FOUND' subtitle='The provided `subscription_id` could not be found.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`subscription_id`}</inlineCode>{` was never created, or contains a typo.`}</li>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`subscription_id`}</inlineCode>{` belongs to a different client.`}</li>
        <li parentName="ul">{`The subscription was already deleted.`}</li>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`subscription_id`}</inlineCode>{` was created in a different environment (Sandbox vs Production).`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='SUBSCRIPTION_NOT_FOUND' mdxType="Checkbox">
        <p>{`Confirm you are calling the same API environment (Sandbox or Production) the subscription was created in.`}</p>
      </Checkbox>
      <Checkbox checklistId='SUBSCRIPTION_NOT_FOUND_2' mdxType="Checkbox">
        <p>{`If you are deleting a subscription, treat this error as success: the subscription is already gone, and deletion is safe to retry.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "subscription_already_exists"
    }}><strong parentName="h4">{`SUBSCRIPTION_ALREADY_EXISTS`}</strong></h4>
    <ErrorReference type='CRA_MONITORING_ERROR' error='SUBSCRIPTION_ALREADY_EXISTS' subtitle='The user already has an active subscription of the requested kind.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The user already has an active subscription and can hold only one of this kind at a time.`}</li>
        <li parentName="ul">{`A create call was retried after the original call had already succeeded.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='SUBSCRIPTION_ALREADY_EXISTS' mdxType="Checkbox">
        <p>{`Retrieve the user's existing subscription and its `}<inlineCode parentName="p">{`subscription_id`}</inlineCode>{` before creating a new one.`}</p>
      </Checkbox>
      <Checkbox checklistId='SUBSCRIPTION_ALREADY_EXISTS_2' mdxType="Checkbox">
        <p>{`To change the products or webhook on an existing subscription, update it rather than creating a second one. Delete the existing subscription first only if you need to recreate it from scratch.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "subscription_limit_exceeded"
    }}><strong parentName="h4">{`SUBSCRIPTION_LIMIT_EXCEEDED`}</strong></h4>
    <ErrorReference type='CRA_MONITORING_ERROR' error='SUBSCRIPTION_LIMIT_EXCEEDED' subtitle='The user has reached the maximum number of active Servicing subscriptions.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The user already holds the maximum of 10 active subscriptions.`}</li>
        <li parentName="ul">{`Subscriptions were created per report rather than reused, so unused subscriptions have accumulated on the user.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='SUBSCRIPTION_LIMIT_EXCEEDED' mdxType="Checkbox">
        <p>{`Review the user's active subscriptions and delete any that are no longer needed.`}</p>
      </Checkbox>
      <Checkbox checklistId='SUBSCRIPTION_LIMIT_EXCEEDED_2' mdxType="Checkbox">
        <p>{`A single subscription can cover multiple products. Add products to an existing subscription instead of creating an additional one.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "subscription_not_found",
        level: 4,
        title: "SUBSCRIPTION_NOT_FOUND",
      },
{
        id: "subscription_already_exists",
        level: 4,
        title: "SUBSCRIPTION_ALREADY_EXISTS",
      },
{
        id: "subscription_limit_exceeded",
        level: 4,
        title: "SUBSCRIPTION_LIMIT_EXCEEDED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
